// src/components/Screening/TechnicalStep.jsx
import React from 'react'
import { Zap } from 'lucide-react'
import GlowingButton from '../Common/GlowingButton'

const TechnicalStep = ({ criteria, onCriteriaChange, onNext, onPrev }) => {
  return (
    <div className="space-y-8">
      <div className="text-center">
        <div className="relative inline-block mb-6">
          <div className="absolute inset-0 bg-gradient-to-r from-green-500 to-blue-500 rounded-3xl blur-lg opacity-50 animate-pulse"></div>
          <div className="relative w-20 h-20 bg-gradient-to-r from-green-500 to-blue-500 rounded-3xl flex items-center justify-center shadow-2xl">
            <Zap className="w-10 h-10 text-white" />
          </div>
        </div>
        <h2 className="text-4xl font-bold text-white mb-4">Critères Techniques</h2>
        <p className="text-gray-400 text-lg max-w-3xl mx-auto leading-relaxed">
          Compétences techniques spécialisées pour le profil sélectionné
        </p>
      </div>

      <div className="max-w-4xl mx-auto">
        <div className="glass-card p-6">
          <h4 className="text-white font-medium mb-4 flex items-center">
            <span className="text-2xl mr-3">🛠️</span>
            Compétences techniques requises
          </h4>
          <textarea
            key={criteria.selectedProfile}
            defaultValue={criteria.customTechnicalSkills || ''}
            onChange={(e) => onCriteriaChange('customTechnicalSkills', e.target.value)}
            onInput={(e) => onCriteriaChange('customTechnicalSkills', e.target.value)}
            rows={8}
            className="w-full p-4 border border-gray-600 rounded-lg bg-gray-800/50 text-white focus:ring-2 focus:ring-blue-500 resize-none"
            placeholder="Ex: 
- Langages: JavaScript, Python, TypeScript
- Frameworks: React, Node.js, Django  
- Outils: Git, Docker, AWS
- Bases de données: PostgreSQL, MongoDB
- Méthodologies: Agile, Scrum"
          />
<div className="mt-3 text-sm text-gray-400">
           💡 <strong>Astuce :</strong> Listez les compétences essentielles, certifications, logiciels ou technologies spécifiques au poste.
         </div>
       </div>

       {/* Conseils selon le profil */}
       {criteria.selectedProfile && (
         <div className="mt-6 p-4 bg-blue-500/10 border border-blue-500/20 rounded-lg">
           <h5 className="text-blue-300 font-medium mb-2">💡 Conseils pour ce profil :</h5>
           <div className="text-blue-200 text-sm">
             {criteria.selectedProfile === 'dev-fullstack' && (
               <div>
                 • Langages front-end (JavaScript, TypeScript, HTML/CSS)<br/>
                 • Frameworks (React, Angular, Vue.js)<br/>
                 • Back-end (Node.js, Python, Java)<br/>
                 • Bases de données (SQL, NoSQL)<br/>
                 • DevOps (Docker, AWS, CI/CD)
               </div>
             )}
             {criteria.selectedProfile === 'dev-frontend' && (
               <div>
                 • JavaScript/TypeScript avancé<br/>
                 • Frameworks modernes (React, Vue, Angular)<br/>
                 • CSS/SASS, responsive design<br/>
                 • Outils de build (Webpack, Vite)<br/>
                 • Tests (Jest, Cypress)
               </div>
             )}
             {criteria.selectedProfile === 'dev-backend' && (
               <div>
                 • Langages serveur (Python, Java, Node.js, Go)<br/>
                 • API REST/GraphQL<br/>
                 • Bases de données (SQL/NoSQL)<br/>
                 • Architecture microservices<br/>
                 • Sécurité et performance
               </div>
             )}
             {criteria.selectedProfile === 'data-scientist' && (
               <div>
                 • Python (Pandas, NumPy, Scikit-learn)<br/>
                 • Machine Learning, Deep Learning<br/>
                 • SQL, big data (Spark, Hadoop)<br/>
                 • Visualisation (Matplotlib, Tableau)<br/>
                 • Statistiques avancées
               </div>
             )}
             {criteria.selectedProfile === 'comptable' && (
               <div>
                 • Logiciels comptables (SAP, Sage, Ciel)<br/>
                 • Excel avancé, VBA<br/>
                 • Normes comptables (IFRS, PCG)<br/>
                 • Fiscalité (TVA, IS, liasses)<br/>
                 • Audit et contrôle interne
               </div>
             )}
             {criteria.selectedProfile === 'marketing' && (
               <div>
                 • Marketing digital (SEO/SEM, Google Ads)<br/>
                 • Analytics (Google Analytics, Data Studio)<br/>
                 • CRM (HubSpot, Salesforce)<br/>
                 • Automation marketing<br/>
                 • Réseaux sociaux professionnels
               </div>
             )}
             {criteria.selectedProfile === 'commercial' && (
               <div>
                 • CRM (Salesforce, Pipedrive)<br/>
                 • Techniques de vente et négociation<br/>
                 • Prospection digitale (LinkedIn Sales)<br/>
                 • Gestion pipeline commercial<br/>
                 • Analyse des KPI de vente
               </div>
             )}
             {!['dev-fullstack', 'dev-frontend', 'dev-backend', 'data-scientist', 'comptable', 'marketing', 'commercial'].includes(criteria.selectedProfile) && (
               <div>
                 Décrivez les compétences techniques essentielles pour ce poste selon votre secteur d'activité.
               </div>
             )}
           </div>
         </div>
       )}
     </div>

     <div className="flex justify-center space-x-4 pt-8">
       <GlowingButton variant="secondary" onClick={onPrev}>
         ← Retour
       </GlowingButton>
       <GlowingButton onClick={onNext}>
         Continuer →
       </GlowingButton>
     </div>
   </div>
 )
}

export default TechnicalStep